import MenuButton from './menu-button';
import './global-header.scss';
import './mega-menu.scss';

const menuButtonConfig = {
  name: 'menu-button',
  class: MenuButton,
  querySelector: {},
  querySelectorAll: {},
  options: {},
};

export default menuButtonConfig;
